'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import contractorAction from '../../actions/contractorAction';
import contractorStore from '../../stores/contractorStore';
import userStore from '../../stores/userStore';
import genFunction from '../../functions/genFunction';
import ModalStaff from './modalStaff';
import ReminderModal from './reminderModal';

class ContractorFilter extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onUserChange = this.onUserChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.handleCondoChange = this.handleCondoChange.bind(this);
        this.handleExpire = this.handleExpire.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        //this.handleShowAll = this.handleShowAll.bind(this);
        this.handleCreateContractor = this.handleCreateContractor.bind(this);
        this.handleCreateCondo = this.handleCreateCondo.bind(this);
        this.handleStaffChange = this.handleStaffChange.bind(this);
        this.replaceStaff = this.replaceStaff.bind(this);
        this.handleShowContractor = this.handleShowContractor.bind(this);
        this.handleShowRecipient = this.handleShowRecipient.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.shouldModalCloseReminder = this.shouldModalCloseReminder.bind(this);
        this.state = {
            searchMode: contractorStore.getState().searchMode,
            search: contractorStore.getState().search,
            mcst: contractorStore.getState().mcst,
            staffId: contractorStore.getState().staffId,
            reminderEmail: contractorStore.getState().reminderEmail,
            warningMsg: contractorStore.getState().warningMsg,

            permission: userStore.getState().permission,
            subordinate: userStore.getState().subordinate,
            userId: userStore.getState().staffId,

            modalClose: false,
            modalCloseReminder: false,
        };
    }
    componentDidMount() {
        contractorStore.listen(this.onChange);
        userStore.listen(this.onUserChange);
    }
    componentWillUnmount() {
        contractorStore.unlisten(this.onChange);
        userStore.unlisten(this.onUserChange);
    }
    onChange(state) {
        this.setState({
            mcst: state.mcst,
            search: state.search,
            warningMsg: state.warningMsg,
            staffId: state.staffId,
            searchMode: state.searchMode,
            reminderEmail: state.reminderEmail,
        });
    }
    onUserChange(state) {
        this.setState({
            permission: state.permission,
            subordinate: state.subordinate,
            userId: state.staffId
        });
    }
    handleSearch(e) {
        let value = e.target.value;
        contractorAction.search(value);
        contractorAction.updating(false);

        contractorAction.warningMsg("");
        contractorAction.isNew(false);
    }
    handleKeyPress(e){
        if(e.key == 'Enter'){
            e.preventDefault();
            this.handleFilter();
        }
    }
    handleCondoChange(e) {
        let value = e.target.value;
        contractorAction.mcst(value);
    }
    handleStaffChange(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        let value = e.target.value;
        if (index == 4) {
            contractorAction.staffId(value);
        } else if (index == 5) {
            contractorAction.oldStaffId(value);
        } else {
            contractorAction.newStaffId(value);
        }
    }
    handleShowRecipient() {
        this.setState({ modalCloseReminder: true });
    }
    /*
   handleShowAll() {
      
       if (this.props.processing) return;

       contractorAction.processing(true);
       contractorAction.getAllContractor();
       contractorAction.searchMode(1);

       contractorAction.updating(false);
       contractorAction.warningMsg("");
       contractorAction.isNew(false);
       
   }
   */
    handleShowContractor() {
        if (this.props.processing) return;

        contractorAction.processing(true);
        contractorAction.listClear();
        contractorAction.getContractorByFilter(this.state.mcst, this.state.staffId);
        contractorAction.searchMode(3);
        //clear service
        contractorAction.search("");

        contractorAction.updating(false);
        contractorAction.warningMsg("");
        contractorAction.isNew(false);
    }
    handleFilter(e) {
        if (this.props.processing) return;
        if (this.state.search == "") return contractorAction.warningMsg("Empty Input");
        contractorAction.processing(true);
        contractorAction.listClear();
        contractorAction.getContractorByService(this.state.search);
        contractorAction.searchMode(0);
        //clear staffId and mcst
        contractorAction.staffId("");
        contractorAction.mcst("");

        contractorAction.updating(false);
        contractorAction.warningMsg("");
        contractorAction.isNew(false);
    }
    handleExpire() {
        if (this.props.processing) return;

        contractorAction.processing(true);
        contractorAction.listClear();
        contractorAction.getExpireContractor(this.state.mcst, this.state.staffId);
        contractorAction.searchMode(2);
        //clear service
        contractorAction.search("");

        contractorAction.updating(false);
        contractorAction.warningMsg("");
        contractorAction.isNew(false);
    }
    handleExportCheckList(){
        contractorAction.processing(true);
        contractorAction.exportCondoCheckList();
    }
    handleCreateContractor() {
        this.props.history.push('/newContractor');
    }
    handleCreateCondo() {
        this.props.history.push('/newCondo');
    }
    replaceStaff() {
        this.setState({ modalClose: true });
    }
    shouldModalClose(data) {
        this.setState({
            modalClose: data
        });
    }
    shouldModalCloseReminder(data) {
        this.setState({
            modalCloseReminder: data
        });
    }
    renderStaffs() {
        return this.props.staffs.map((staff, index) => {
            return (
                <option value={staff.staffId} key={index}>{staff.userName}</option>
            );
        });
    }


    renderCondos() {
        return this.props.condos.map((condo, index) => {
            return (
                <option value={condo.mcst} key={index}>{condo.condoName}</option>
            );
        });
    }
    render() {
        let newContractor = "";
        let modal = '';
        if (this.state.modalCloseReminder) {
            modal = (
                <ReminderModal
                    modalClose={this.state.modalCloseReminder}
                    shouldModalClose={this.shouldModalCloseReminder}
                    reminderEmail={this.state.reminderEmail}
                    processing={this.state.processing}
                    staffs={this.props.staffs}
                    title="Add Recipient"
                />
            );
        }

        if (this.props.isSetting && genFunction.hasPermission(this.state.permission, 6)) {
            /*
                    <div className="atd-i-btn">
                        <button className="btn btn-default btn-sm" onClick={this.handleShowAll}>Show All Contractors/Condos</button>
                    </div>
            */
            newContractor = (
                <div className="col-sm-8">

                    <div className="atd-i-btn">
                        <button className="btn btn-info btn-sm" onClick={this.handleCreateContractor}>Add New Contractor</button>
                    </div>
                    <div className="atd-i-btn">
                        <button className="btn btn-info btn-sm" onClick={this.handleCreateCondo}>Add New Condo</button>
                    </div>
                    <div className="atd-i-btn">
                        <button className="btn btn-info btn-sm" onClick={this.replaceStaff}>Replace Staff</button>
                    </div>
                    <div className="atd-i-btn">
                        <button className="btn btn-info btn-sm" onClick={this.handleShowRecipient}>Add Recipient</button>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <div className="warning">{this.state.warningMsg}</div>
                <div className="report-i-1 row">
                    <div className="col-md-4 col-lg-4">
                        <form className="form-horizontal atd-i-wp">
                            <label htmlFor="contractorName" className="col-xs-6 col-md-6 col-lg-5 control-label">Contractor Service: </label>
                            <div className="input-group input-group-sm">
                                <input type="text" className="form-control" id="contractorName" placeholder="Search By Services" 
                                    value={this.state.search} onChange={this.handleSearch} onKeyPress={this.handleKeyPress} />
                                <span className="input-group-btn">
                                    <button className="btn btn-default" type="button" onClick={this.handleFilter}>Filter</button>
                                </span>
                            </div>
                        </form>
                    </div>
                    {newContractor}
                </div>
                <div className=" row">
                    <h5><b>Filter Contractor By:</b></h5>
                    <div className="col-md-4 col-lg-4">
                        <form className="form-horizontal atd-i-wp">
                            <label htmlFor="staff" className="col-xs-6 col-md-6 col-lg-5 control-label">Staff: </label>
                            <div className="input-group input-group-sm">
                                <select className="form-control atd-sel" name="staff" data-index="4" onChange={this.handleStaffChange} value={this.state.staffId}>
                                    <option value="">Any Staff</option>
                                    {this.renderStaffs()}
                                </select>
                            </div>
                        </form>
                        <form className="form-horizontal atd-i-wp">
                            <label htmlFor="condoName" className="col-xs-6 col-md-6 col-lg-5 control-label">Estate: </label>
                            <div className="input-group input-group-sm">
                                <select className="form-control atd-sel" name="condoName" data-index="3" onChange={this.handleCondoChange} value={this.state.mcst}>
                                    <option value="">Any Condo</option>
                                    {this.renderCondos()}
                                </select>
                            </div>
                        </form>
                    </div>

                    <div className="col-md-8 col-lg-8">
                        <div className="atd-i-btn">
                            <button className="btn btn-default btn-sm" onClick={this.handleShowContractor}>Show Contractors/Condos</button>
                        </div>
                        <div className="atd-i-btn">
                            <button className="btn btn-default btn-sm" onClick={this.handleExpire}>Contracts Expiring/Expired</button>
                        </div>
                        <div className="atd-i-btn">
                            <button className="btn btn-default btn-sm" onClick={this.handleExportCheckList}>Export Condo CheckList</button>
                        </div>
                    </div>
                </div>
                <ModalStaff processing={this.props.processing} modalClose={this.state.modalClose}
                    shouldModalClose={this.shouldModalClose} staffs={this.props.staffs}
                />
                {modal}
            </div >
        );
    }
}

export default ContractorFilter;


// WEBPACK FOOTER //
// ./app/setComponents/contractorComponents/contractorFilter.js